import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React, { useContext } from 'react';

import EditorZoom from './ssEditorZoom';
import RuntimeZoom from './ssRuntimeZoom';
import { useFormSelector } from '../../../custom-hooks';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_BORDER_STYLES, FCM_HIDDEN_CONTROL_STYLES } from '../../constants/runtime.constants';
import { SubGridContext } from '../../context';
import { getIsFormChangesMode } from '../../selectors/common.selectors';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    padding: '8px 0',
  },
  changesModeWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: ({ isControlChangedFCM }) => `36px ${isControlChangedFCM ? 26 : 6}px 0px 6px`,
  },
  coloredBorder: {
    border: FCM_BORDER_STYLES.CONDITIONAL,
  },
  hiddenControl: FCM_HIDDEN_CONTROL_STYLES,
  changesIcon: {
    position: 'absolute',
    top: 4,
    right: 8,
  },
  smallPaddingTop: {
    paddingTop: '6px !important',
  },
});

const SSZoom = ({
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  ...props
}) => {
  const classes = useStyles({ isControlAddedFCM, isControlChangedFCM });
  const inSubGrid = useContext(SubGridContext);
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);

  const { textBoxPropsJson = '{}', inTable, id } = props;
  const { isTextBoxViewOnly, isTextBoxHidden } = JSON.parse(textBoxPropsJson);
  const isHidden = isControlHiddenFCM || isTextBoxViewOnly || isTextBoxHidden;

  if (isEditor) {
    return <EditorZoom {...props} />;
  }

  if (!isFormChangesMode) {
    return <RuntimeZoom {...props} />;
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.root}>
        <div
          className={classNames(classes.changesModeWrapper, classes.coloredBorder)}
          data-ss-id={props.id}
        >
          <span className={isHidden ? classes.hiddenControl : null} data-hidden-fcm={isHidden}>
            <RuntimeZoom {...props} />
          </span>
          {isControlChangedFCM && (
            <div className={classes.changesIcon}>
              <ControlChangesIcon id={id} />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={classNames(classes.root, isHidden ? classes.hiddenControl : '')}
      data-hidden-fcm={isHidden}
    >
      <div
        className={classNames(
          classes.changesModeWrapper,
          inSubGrid || inTable || isTextBoxViewOnly ? classes.smallPaddingTop : ''
        )}
      >
        <RuntimeZoom {...props} />
      </div>
    </div>
  );
};

export default SSZoom;
